<template>
  <v-container fluid>
    <Resource
      :create-form-component="() => import('../components/forms/ThirdParty.vue')"
      :meta="{name: 'Derde partij', namePlural: 'Derde partijen'}"
      :table-content="tableContent"
      :update-form-component="() => import('../components/forms/ThirdParty.vue')"
      resource-uri="third-party"
      can-search
    />
  </v-container>
</template>
<script>
import Resource from '@/components/Resource.vue';

export default {
  components: {Resource},
  name: 'ThirdPartyResource',
  data() {
    return {
      tableContent: [
        {
          text: 'Naam',
          align: 'left',
          sortable: true,
          value: 'name',
        },
      ],
    };
  },
  methods: {
    mapDataResponse(data) {
      return data.map((row) => {
        row.organisation_names = row.organisations.map(organisation => organisation.name).join(', ');

        return row;
      });
    },
  },
};
</script>
